module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Valuta","track":"Currency"}}